// extracted by mini-css-extract-plugin
export var chevron = "_j1-2";
export var dropdownItems = "_j1-0";
export var item = "_j1-1";